import { DEFAULT_LOCALE, Locale, toLocale } from '@longy/common'

/** The key `LanguageSelect` already writes to, so the switcher and this reader agree. */
const LOCALE_STORAGE_KEY = 'i18nextLng'

/**
 * The locale a returning visitor last chose, or the default.
 *
 * Server-side this is always the default: there is no storage to read, and returning anything
 * else would make the SSR markup disagree with what the client is about to render.
 */
export const resolveInitialLocale = (): Locale => {
    if (typeof window === 'undefined') return DEFAULT_LOCALE

    try {
        return toLocale(localStorage.getItem(LOCALE_STORAGE_KEY))
    } catch {
        // Private browsing and blocked site data both throw on access rather than returning null.
        return DEFAULT_LOCALE
    }
}
